export function isWorldServerData(value) {
    if (!value || typeof value !== "object" || Array.isArray(value))
        return false;
    const fields = ["cpuPercent", "ramPercent", "diskPercent"];
    const candidate = value;
    return Object.keys(candidate).length === fields.length && fields.every(field => {
        const percent = candidate[field];
        return Object.hasOwn(candidate, field) && (percent === null ||
            (typeof percent === "number" && Number.isFinite(percent) && percent >= 0 && percent <= 100));
    });
}
